import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-comming-soon',
  templateUrl: './login-comming-soon.component.html',
  styleUrls: ['./login-comming-soon.component.scss']
})
export class LoginCommingSoonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
